module.exports = __webpack_public_path__ + "fonts/manrope-extrabold.f7cabd52.woff";